import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { render, createVNode } from 'vue';
import { withInstall } from '../utils/type';
import AlertMessage from './AlertMessage.js';
var globalInstance;
function checkInstance(config) {
  if (!globalInstance) {
    if (!alert.getInstance) {
      console.error('cannot load alert getInstance function, please install AlertMessagePlugin before use it');
      return false;
    } else {
      globalInstance = alert.getInstance(config);
    }
  }
  return true;
}
function alertMessage(message, type, config) {
  if (checkInstance()) {
    return globalInstance.component.exposed.show(message, type, config === null || config === void 0 ? void 0 : config.renderRaw, config === null || config === void 0 ? void 0 : config.duration);
  }
}
export var alert = {
  info: function info(message, config) {
    return alertMessage(message, 'info', config);
  },
  success: function success(message, config) {
    return alertMessage(message, 'success', config);
  },
  warn: function warn(message, config) {
    return alertMessage(message, 'warn', config);
  },
  error: function error(message, config) {
    return alertMessage(message, 'error', config);
  },
  config: function config(_config) {
    if (checkInstance(_config)) {
      globalInstance.component.exposed.config(_config);
    }
  }
};
var AlertMessagePlugin = {
  install: function install(app) {
    alert.getInstance = function () {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var vm = createVNode(AlertMessage, _objectSpread(_objectSpread({}, config), {}, {
        getContainer: function getContainer() {
          return config.container;
        }
      }));
      vm.appContext = app._context;
      var div = document.createElement('div');
      app._container.append(div);
      render(vm, div);
      return vm;
    };
  }
};
export default withInstall(AlertMessage, AlertMessagePlugin);